import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dia-de-los-muertos',
  templateUrl: './dia-de-los-muertos.component.html',
  styleUrls: ['./dia-de-los-muertos.component.scss']
})
export class DiaDeLosMuertosComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/dia-de-los-muertos/dia-de-los-muertos.component.ts